import { render, staticRenderFns } from "./RtaRequest.vue?vue&type=template&id=6f652357&scoped=true"
import script from "./RtaRequest.vue?vue&type=script&lang=js"
export * from "./RtaRequest.vue?vue&type=script&lang=js"
import style0 from "./RtaRequest.vue?vue&type=style&index=0&id=6f652357&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f652357",
  null
  
)

export default component.exports